import React, { useContext } from "react";
import styled from "styled-components";
import SeasonalFlavor from "../common/SeasonalFlavor";

import { CurrentThemeContext } from "./../common/ThemeContextWrapper";
import { ShowLandingContext } from "./../Landing/ShowLandingContextWrapper";
import UnitCanvasContainer from "./../Unit/Canvas/UnitCanvasContainer";
import BaseURL from "./../Unit/data/images/Hosting-BaseURL";

const summerleaves = `${BaseURL}/background/summer-leaves.png`;
const summerforeground = `${BaseURL}/background/summer-foreground.png`;
const summerbackground = `${BaseURL}/background/summer-background.png`;

const autumnLeaves = `${BaseURL}/background/autumn-leaves.png`;
const autumnForeground = `${BaseURL}/background/autumn-foreground.png`;
const autumnBackground = `${BaseURL}/background/autumn-background.png`;

const winterLeaves = `${BaseURL}/background/winter-leaves.png`;
const winterForeground = `${BaseURL}/background/winter-foreground.png`;
const winterBackground = `${BaseURL}/background/winter-background.png`;

const springLeaves = `${BaseURL}/background/spring-leaves.png`;
const springForeground = `${BaseURL}/background/spring-foreground.png`;
const springBackground = `${BaseURL}/background/spring-background.png`;

// const mechLeaves = `${BaseURL}/background/mech-leaves.png`;
const mechForeground = `${BaseURL}/background/mech-foreground.png`;
const mechBackground = `${BaseURL}/background/mech-background.png`;

const images = {
    spring: {
        leaves: springLeaves,
        foreground: springForeground,
        background: springBackground,
    },
    summer: {
        leaves: summerleaves,
        foreground: summerforeground,
        background: summerbackground,
    },
    autumn: {
        leaves: autumnLeaves,
        foreground: autumnForeground,
        background: autumnBackground,
    },
    winter: {
        leaves: winterLeaves,
        foreground: winterForeground,
        background: winterBackground,
    },
    mech: {
        // leaves: winterLeaves,
        foreground: mechForeground,
        background: mechBackground,
    },
    lvoid: {
        // leaves: winterLeaves,
        // foreground: mechForeground,
        // background: mechBackground,
    },
    dvoid: {
        // leaves: winterLeaves,
        // foreground: mechForeground,
        // background: mechBackground,
    },
};

const MainWrapper = styled.div `
    left: 50vw;
    margin-left: -592px;
    margin-right: auto;
    max-width: ${props => props.theme.tabletCutoffWidth + 1}px;
    min-width: ${props => props.theme.tabletCutoffWidth + 1}px;
    height: 1521px;
    opacity: ${props => props.showLanding ? 0 : 1};
    position: relative;
    top: ${props => props.showLanding ? "50px" : "0px"};
    transition-duration: ${props => props.theme.landingTransitionDuration}s;
    transition-property: opacity, top;
    z-index: 2;

    @media print {
        display: none;
    }

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        left: 0;
        margin-left: 0;

        width: 100%;
        height: auto;
        position: relative;
        overflow: hidden;
        padding: 130.56% 0 0 0; /* 130.56% = 100 / (w / h) = 100 / (1165 / 1521) */
    }

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        height: 100vh;
        width: 100vw;
        left: 0;
        margin-left: 0;
        min-width: 100vw;
    }
`;

MainWrapper.displayName = "MainWrapper";

const BackgroundImage = styled.picture`
    margin-top: ${props => props.showLanding ? "-50px" : "-10px"};
    max-width: 100%;
    opacity: ${props => props.showLanding ? 0 : 1};
    position: absolute;
    top: 0;
    left: 0;
    transition-duration: ${props => props.theme.landingTransitionDuration}s;
    transition-property: opacity, margin-top;
    z-index: 1;

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        max-height: 100%;
        bottom: 0;
        right: 0;
    }

    > img {
        @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
            display: none;
        }
    }
`;

BackgroundImage.displayName = "BackgroundImage";

const ForegroundImage = styled.picture`
    max-width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 3;

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        max-height: 100%;
        bottom: 0;
        right: 0;
    }

    > img {
        @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
            display: none;
        }
    }
`;

ForegroundImage.displayName = "ForegroundImage";

const ForegroundFoliageImage = styled.picture`
    position: absolute;
    top: 0;
    left: 0;
    margin-top: ${props => props.showLanding ? "-45px" : "-25px"};
    max-width: 100%;
    transition-duration: ${props => props.theme.landingTransitionDuration - 1}s;
    transition-property: margin-top;
    z-index: 2;

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        max-height: 100%;
    }

    > img {
        @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
            display: none;
        }
    }
`;

ForegroundFoliageImage.displayName = "ForegroundFoliageImage";

const ForegroundShadow = styled.div`
    width: 100%;
    bottom: 0;
    left: 0;
    height: 30px;
    position: absolute;
    background: linear-gradient(transparent 0%, #000 100%);
    z-index: 4;

    @media only screen and (max-width: ${props => props.theme.mobileCutoffWidth}px) {
        position: fixed;
    }
`;

ForegroundShadow.displayName = "ForegroundShadow";

function MainBackgroundContainer() {
    const { showLanding } = useContext(ShowLandingContext);
    const { currentTheme, themeDetails } = useContext(CurrentThemeContext);

    return (
        <MainWrapper showLanding={showLanding}  onContextMenu={(e) => e.preventDefault()}>
            {images[currentTheme].leaves ?
                <ForegroundFoliageImage showLanding={showLanding}>
                    <source
                        srcSet={images[currentTheme].leaves}
                        media={`(min-width: ${themeDetails.tabletCutoffWidth}px)`}
                    />
                    <img alt="foliage" />
                </ForegroundFoliageImage> : null
            }
            {images[currentTheme].foreground ?
                <ForegroundShadow /> : null
            }
            {images[currentTheme].foreground ?
                <ForegroundImage>
                    <source
                        srcSet={images[currentTheme].foreground}
                        media={`(min-width: ${themeDetails.tabletCutoffWidth}px)`}
                    />
                    <img alt="foreground" />
                </ForegroundImage> : null
            }

            <SeasonalFlavor background />

            {images[currentTheme].background ?
                <BackgroundImage showLanding={showLanding}>
                    <source
                        srcSet={images[currentTheme].background}
                        media={`(min-width: ${themeDetails.tabletCutoffWidth}px)`}
                    />
                    <img alt="background" />
                </BackgroundImage> : null
            }
            <UnitCanvasContainer />
        </MainWrapper>
    );
}

export default MainBackgroundContainer;
